import { roundPriceCents } from '@bondsports/general';

export const defaultLabels = {
	subtotal: 'Subtotal',
	discounts: 'Discounts',
	tax: 'Tax',
	fees: (percentage: number) => {
		if (!percentage) {
			return 'Fees';
		}

		return `Fees (${roundPriceCents(percentage * 100)}%)`;
	},
	total: 'Total',
	taxInclusive: 'Inc.',
	taxExclusive: '',
};

export type SummaryLabels = typeof defaultLabels;
